'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_DURATION = exports.HIDE_TOAST = exports.SHOW_TOAST = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.toastsReducer = toastsReducer;
exports.show = show;
exports.hide = hide;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _uuid = require('./uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_TOAST = exports.SHOW_TOAST = 'toast/SHOW';
var HIDE_TOAST = exports.HIDE_TOAST = 'toast/HIDE';

var DEFAULT_DURATION = exports.DEFAULT_DURATION = 3000;

var defaultState = [];

function toastsReducer(state, action) {
  switch (action.type) {
    case SHOW_TOAST:
      var showId = action && action.payload && action.payload.id ? action.payload.id : (0, _uuid2.default)();

      var _ref = action.payload || {},
          target = _ref.target,
          rest = (0, _objectWithoutProperties3.default)(_ref, ['target']);

      return [].concat((0, _toConsumableArray3.default)(state), [(0, _extends3.default)({
        id: showId,
        target: target || 'toasts'
      }, rest)]);

    case HIDE_TOAST:
      (0, _invariant2.default)(action.payload && action.payload.id, 'You need to define the \'id\' of toast that you want to close!');
      return (state || []).filter(function (t) {
        return t.id !== action.payload.id;
      });

    default:
      return state || defaultState;
  }
}

function show(payload) {
  return {
    type: SHOW_TOAST,
    payload: payload
  };
}

function hide(payload) {
  (0, _invariant2.default)(payload && payload.id, 'Cannot trigger hide action without \'id\' specified!');
  return {
    type: HIDE_TOAST,
    payload: payload
  };
}